"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getUserByID_1 = __importDefault(require("./getUserByID"));
const exchangeCode_1 = __importDefault(require("./exchangeCode"));
const getLoggedInUser_1 = __importDefault(require("./getLoggedInUser"));
const connectWallet_1 = require("./connectWallet");
const loginWithPrivy_1 = require("./loginWithPrivy");
const getUserByUsername_1 = __importDefault(require("./getUserByUsername"));
const disconnectWallet_1 = require("./disconnectWallet");
const getConnectionMessage_1 = require("./getConnectionMessage");
const checkUsername_1 = require("./checkUsername");
const getRegisterActions_1 = require("./getRegisterActions");
const signupWithPrivy_1 = require("./signupWithPrivy");
const getPreregistrationData_1 = require("./getPreregistrationData");
const createGuestAccount_1 = require("./createGuestAccount");
class AuthAPI {
    baseUrl;
    constructor(baseURI) {
        this.baseUrl = baseURI;
    }
    getUserByID = getUserByID_1.default;
    exchangeCode = exchangeCode_1.default;
    connectWallet = connectWallet_1.connectWallet;
    getLoggedInUser = getLoggedInUser_1.default;
    disconnectWallet = disconnectWallet_1.disconnectWallet;
    getUserByUsername = getUserByUsername_1.default;
    createGuestAccount = createGuestAccount_1.createGuestAccount;
    getPreregistrationData = getPreregistrationData_1.getPreregistrationData;
    loginWithPrivy = loginWithPrivy_1.loginWithPrivy;
    getRegisterActions = getRegisterActions_1.getRegisterActions;
    checkUsername = checkUsername_1.checkUsername;
    signupWithPrivy = signupWithPrivy_1.signupWithPrivy;
    static getConnectionMessage = getConnectionMessage_1.getConnectionMessage;
}
exports.default = AuthAPI;
//# sourceMappingURL=index.js.map